/// <reference path="../../common/common/common.ts" />

namespace OfficeGuy.Layout {
    export class Sidebar {
        static ActiveApplicationName: string;
        static IsPageLoad: boolean;

        static Init(): void {
            Sidebar.RefreshMobileTopbar(true);
            Sidebar.RefreshSideMenuCollapsed();

            $(document).on("click.sumit-sidemenu-item-collapse", ".sumit-sidemenu-item-collapse", function () {
                var $Collapse = $(this);
                var Show = !$Collapse.hasClass("sumit-sidemenu-item-collapse-visible");
                if (Show) {
                    $Collapse.addClass("sumit-sidemenu-item-collapse-visible");
                    $Collapse.parent().find(".sumit-sidemenu-item-children").slideDown(200);
                }
                else {
                    $Collapse.removeClass("sumit-sidemenu-item-collapse-visible");
                    $Collapse.parent().find(".sumit-sidemenu-item-children").slideUp(200);
                }
            });
            $(".sumit-sidemenu").addClass("sumit-sidemenu-init");
            var $MobileTopbar = $(".sumit-mobiletopbar");
            var IsScrolled = window.scrollY > 0;
            $(window).on("scroll", function () {
                var NewIsScrolled = window.scrollY > 0;
                if (IsScrolled == NewIsScrolled)
                    return;
                IsScrolled = NewIsScrolled;
                $MobileTopbar.toggleClass("sumit-mobiletopbar-scrolled", IsScrolled);
            });
        }
        static RefreshSideMenuCollapsed() {
            if (Teva.Storage.LocalStorage_Get("SideMenuCollapsed") == "1") {
                $(".sumit-sidemenu")
                    .addClass("sumit-sidemenu-collapsed sumit-sidemenu-collapsed-stable");
                $("#main-page").addClass("main-page-sidemenucollapsed");
            }
            else {
                $(".sumit-sidemenu")
                    .removeClass("sumit-sidemenu-collapsed sumit-sidemenu-collapsed-stable");
                $("#main-page").removeClass("main-page-sidemenucollapsed");
            }
        }
        static PageLoad() {
            Sidebar.IsPageLoad = true;
            if (OfficeGuy.Common.IsBrowserLowResolution())
                Sidebar.SetMode(false);
            Sidebar.RefreshMobileTopbar(false);
        }
        static Hide(): void {
            if (OfficeGuy.Common.IsBrowserLowResolution())
                return;
            var $SideMenu = $(".sumit-sidemenu");
            if (!Sidebar.IsPageLoad)
                $SideMenu.hide();
            if ($SideMenu.length > 0) {
                $("#main-page").addClass("main-page-sidemenuhidden");
                $(document).one("Teva.PageLoad", function () {
                    $("#main-page").removeClass("main-page-sidemenuhidden");
                });
            }
            if (!Sidebar.IsPageLoad) {
                setTimeout(function () {
                    $SideMenu.show();
                }, 1);
            }
        }
        static SetMode(Open): void {
            var $Sidebar = $(".sumit-sidebar");
            if ($Sidebar.length == 0)
                return;

            $Sidebar.toggleClass("sumit-sidebar-open", Open);
            $(document).one("Teva.PageLoad", function () {
                $Sidebar.removeClass("sumit-sidebar-open");
            });
        }
        static GetMode(): boolean {
            return $(".sumit-sidebar").hasClass("sumit-sidebar-open");
        }
        static ToggleMode(): boolean {
            var $SideMenu = $(".sumit-sidemenu");
            if ($SideMenu.hasClass("sumit-sidemenu-open") && $(".sumit-sidemenu-content:not(.sumit-sidemenu-content-hide)").data("applicationname") != 'mymodules') {
                $SideMenu.removeClass("sumit-sidemenu-open");
                return false;
            }

            var Mode = Sidebar.GetMode();
            Sidebar.SetMode(!Mode);
            if (!Mode && Common.IsBrowserLowResolution()) {
                var $SideMenu = $SideMenu;
                $SideMenu.removeClass("sumit-sidemenu-open");
            }
            return false;
        }
        static SetActiveApplication(ApplicationName, ActiveSidebar): void {
            if ($(".sumit-sidemenu-header[data-applicationname='BooksHeader']").length > 0) {
                if (ApplicationName == 'Books')
                    ApplicationName = 'BooksCompany';
                if (ApplicationName == 'BooksHome' || ApplicationName == 'BooksCompany') {
                    $(".sumit-sidemenu-item:not(.sumit-sidemenu-item-hidden):not([data-applicationname=BooksCompany]):not([data-applicationname=BooksHome]):not([data-applicationname=Home])").hide();
                    $(".sumit-sidemenu-header:not([data-applicationname=BooksHeader])").hide();
                    $(".sumit-sidebar-item-bookshomecontainer").show();
                }
                else {
                    $(".sumit-sidemenu-item:not(.sumit-sidemenu-item-hidden):not([data-applicationname=Home])").show();
                    $(".sumit-sidemenu-header").show();
                    //$(".sumit-sidemenu-header[data-applicationname=BooksMyModules]").hide();
                    $(".sumit-sidebar-item-bookshomecontainer").hide();
                }
            }

            var $ActiveSidebar = $(".sumit-sidebar-item-active");
            if (ActiveSidebar == null || ActiveSidebar == "")
                ActiveSidebar = "MyModules";
            if ($ActiveSidebar.length == 0 || $ActiveSidebar.attr("data-sidebar") != ActiveSidebar) {
                $ActiveSidebar.removeClass("sumit-sidebar-item-active");
                $(".sumit-sidebar-item[data-sidebar=" + ActiveSidebar + "]").addClass("sumit-sidebar-item-active");
            }

            Sidebar.ActiveApplicationName = ApplicationName;
            var $Menu = $(".sumit-sidemenu-content:not(.sumit-sidemenu-content-hide)");
            if ($Menu.length == 0)
                $Menu = $(".sumit-sidemenu");

            var $PreviousLink = $Menu.find(".sumit-sidemenu-item-active");

            var $Link = null;
            if (ApplicationName.length != 0)
                $Link = $Menu.find(".sumit-sidemenu-item[data-applicationname='" + ApplicationName + "']");
            if ($Link == null || $Link.length == 0) {
                var CurrentPath = window.location.pathname + window.location.search;
                $Link = $Menu.find(".sumit-sidemenu-item-inner[href='" + CurrentPath + "']:first").closest(".sumit-sidemenu-item");
                if ($Link.length == 0)
                    $Link = $Menu.find(".sumit-sidemenu-item-inner").filter(function () {
                        var Href = $(this).attr("href");
                        if (CurrentPath.indexOf('/wizard/') != -1)
                            return Href == "/companies/wizard/";
                        else if (Href != '/')
                            return CurrentPath.indexOf(Href) == 0;
                        else
                            return false;
                    }).first().closest(".sumit-sidemenu-item");
            }
            if ($PreviousLink.length == 1 && $Link.length == 1 && $PreviousLink[0] == $Link[0])
                return;

            $PreviousLink
                .removeClass("sumit-sidemenu-item-active")
                .find(".sumit-sidemenu-item-children").slideUp(200);
            $PreviousLink.find(".sumit-sidemenu-item-collapse").removeClass("sumit-sidemenu-item-collapse-visible");

            $Link
                .addClass("sumit-sidemenu-item-active")
                .find(".sumit-sidemenu-item-children").slideDown(200);
            $Link.find(".sumit-sidemenu-item-collapse").addClass("sumit-sidemenu-item-collapse-visible");
        }
        static ShowAdditional() {
            if (Common.IsBrowserLowResolution()) {
                var $SideMenu = $(".sumit-sidemenu");
                $SideMenu.addClass("sumit-sidemenu-open");
                $SideMenu.find(".sumit-sidemenu-content[data-applicationname!='mymodules']").removeClass('sumit-sidemenu-content-hide');
                $SideMenu.find(".sumit-sidemenu-content[data-applicationname='mymodules']").addClass('sumit-sidemenu-content-hide');

                $(document).one("Teva.PageLoad", function () {
                    $SideMenu.removeClass("sumit-sidemenu-open");
                });
            }
            return false;
        }
        static ShowApps() {
            if ((<any>window.event).ctrlKey || (<any>window.event).shiftKey)
                window.open('/');
            else if (Common.IsBrowserLowResolution()) {
                Sidebar.SetMode(false);
                var $SideMenu = $(".sumit-sidemenu");
                $SideMenu.find(".sumit-sidemenu-content[data-applicationname='mymodules']").removeClass('sumit-sidemenu-content-hide');
                $SideMenu.find(".sumit-sidemenu-content[data-applicationname!='mymodules']").addClass('sumit-sidemenu-content-hide');
                $SideMenu.addClass("sumit-sidemenu-open");

                $(document).one("Teva.PageLoad", function () {
                    $SideMenu.removeClass("sumit-sidemenu-open");
                });
            }
            else
                Navigation.Redirect("/");
            return false;
        }
        static RefreshMobileTopbar(IsInit: boolean) {
            var $AdditionalSideMenu = $("#main-content").find(".sumit-sidemenu-content");
            var $ExistingSideMenu = $("#main-page > .sumit-sidemenu > .sumit-sidemenu-content:not(.sumit-sidemenu-content-hide)");
            if ($ExistingSideMenu.length != 0 && $AdditionalSideMenu.data("applicationname") == $ExistingSideMenu.data("applicationname")) {
                $AdditionalSideMenu.remove();
                return;
            }

            $ExistingSideMenu.addClass("sumit-sidemenu-content-hide");
            if ($ExistingSideMenu.data("applicationname") != "mymodules") {
                setTimeout(function () {
                    $ExistingSideMenu.remove();
                }, 1000);
            }

            $(".sumit-mobiletopbar").toggleClass("sumit-mobiletopbar-homepage", window.location.pathname == "/");
            $(".sumit-mobiletopbar-title").html($(".og-navigation-bar h1").html());

            if ($AdditionalSideMenu.length > 0) {
                $("#main-page > .sumit-sidemenu > .sumit-sidemenu-content").addClass("sumit-sidemenu-content-hide");
                if (IsInit)
                    $AdditionalSideMenu.prependTo($("#main-page > .sumit-sidemenu"));
                else {
                    $AdditionalSideMenu
                        .addClass("sumit-sidemenu-content-hide")
                        .prependTo($("#main-page > .sumit-sidemenu"));
                    setTimeout(function () {
                        $AdditionalSideMenu.removeClass("sumit-sidemenu-content-hide");
                    }, 1);
                }
            }
            else
                $("#main-page > .sumit-sidemenu > .sumit-sidemenu-content[data-applicationname=mymodules]").removeClass("sumit-sidemenu-content-hide");

        }
        static ToggleSideMenu() {
            var $SideMenu = $(".sumit-sidemenu");
            var Collapsed = !$SideMenu.hasClass("sumit-sidemenu-collapsed");
            Teva.Storage.LocalStorage_Set("SideMenuCollapsed", Collapsed ? "1" : null);
            $SideMenu.toggleClass("sumit-sidemenu-collapsed", Collapsed).removeClass("sumit-sidemenu-collapsed-stable");
            if (Collapsed) {
                setTimeout(function () {
                    if ($SideMenu.hasClass("sumit-sidemenu-collapsed"))
                        $SideMenu.addClass("sumit-sidemenu-collapsed-stable");
                }, 200);

            }
            $("#main-page").toggleClass("main-page-sidemenucollapsed", Collapsed);
            $(window).trigger("resize");
            return false;
        }
        static Back() {
            if (Smooth.StatesCount > 0)
                window.history.back();
            else
                Navigation.Redirect("/");
            return false;
        }
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.Layout.Sidebar.Init();
});
$(document).on("Teva.PageLoad", function (Event, IsInitialization) {
    if (!IsInitialization)
        OfficeGuy.Layout.Sidebar.PageLoad();
});